var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.24512C6.49 2.24512 2 6.73512 2 12.2451C2 17.7551 6.49 22.2451 12 22.2451C17.51 22.2451 22 17.7551 22 12.2451C22 6.73512 17.51 2.24512 12 2.24512ZM15.36 14.5451C15.65 14.8351 15.65 15.3151 15.36 15.6051C15.21 15.7551 15.02 15.8251 14.83 15.8251C14.64 15.8251 14.45 15.7551 14.3 15.6051L12 13.3051L9.7 15.6051C9.55 15.7551 9.36 15.8251 9.17 15.8251C8.98 15.8251 8.79 15.7551 8.64 15.6051C8.35 15.3151 8.35 14.8351 8.64 14.5451L10.94 12.2451L8.64 9.94512C8.35 9.65512 8.35 9.17512 8.64 8.88512C8.93 8.59512 9.41 8.59512 9.7 8.88512L12 11.1851L14.3 8.88512C14.59 8.59512 15.07 8.59512 15.36 8.88512C15.65 9.17512 15.65 9.65512 15.36 9.94512L13.06 12.2451L15.36 14.5451Z",
    fill: "#596780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.de05ea07b3a6083a908e45386c14c05c.svg";
export { ForwardRef as ReactComponent };